import axios from 'axios';

const deletePastTour = async (tourId: string) => {
  await axios.post(`/tours/${tourId}/delete_past_tour`);
};

export default deletePastTour;
